import { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  Tabs,
  Tab,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import PermissionModal from "../../Modals/PermissionModel";

function AgentModal({ show, handleClose, agentData, fetchAgents, roletype }) {
  const [activeTab, setActiveTab] = useState("employee");
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [errors, setErrors] = useState({});
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [allowedPermissions, setAllowedPermissions] = useState([]);

  const [formData, setFormData] = useState({
    emp_id: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    date_joined: "",
    attendence_type: "web/app",
    role: roletype,
    user_permissions: [],
    designation: "",
    department: "",
    gender: "",
    employment_type: "permanent",
    is_location: false,

    family: {
      father_first_name: "",
      father_last_name: "",
      mother_first_name: "",
      mother_last_name: "",
      marital_status: "",
      spouse_first_name: "",
      spouse_last_name: "",
    },
    bank: {
      account_no: "",
      bank_name: "",
      ifsc: "",
      branch: "",
      payment_type: "",
    },
    other: {
      blood_group: "",
      religion: "",

      nationality: "",
    },
    salary: {
      earnings: {
        basic: "",
        hra: "",
        conveyance: "",
        special: "",
        other: "",
      },
      deductions: {
        advance: "",
        other: "",
      },
    },
    qualifications: [
      { qualification: "", board: "", marks: "", grade: "", year: "" },
    ],
    experiences: [
      {
        company: "",
        designation: "",
        years: "",
        salary: "",
        reason: "",
      },
    ],
    resident: {
      res_address: "",
      res_country: "",
      res_state: "",
      res_city: "",
      res_pincode: "",
    },

    permanent: {
      perm_same_as_res: false,

      perm_address: "",
      perm_country: "",
      perm_state: "",
      perm_city: "",
      perm_pincode: "",
    },
    contact: {
      mobile_no: "",
      emergency_no: "",
    },
  });

  const EMPTY_FAMILY = {
    father_first_name: "",
    father_last_name: "",
    mother_first_name: "",
    mother_last_name: "",
    marital_status: "",
    spouse_first_name: "",
    spouse_last_name: "",
  };

  const EMPTY_BANK = {
    account_no: "",
    bank_name: "",
    ifsc: "",
    branch: "",
    payment_type: "",
  };

  const EMPTY_OTHER = {
    blood_group: "",
    religion: "",
    nationality: "",
  };

  const EMPTY_CONTACT = {
    mobile_no: "",
    emergency_no: "",
  };

  const EMPTY_RESIDENT = {
    res_address: "",
    res_country: "",
    res_state: "",
    res_city: "",
    res_pincode: "",
  };

  const EMPTY_PERMANENT = {
    perm_same_as_res: false,
    perm_address: "",
    perm_country: "",
    perm_state: "",
    perm_city: "",
    perm_pincode: "",
  };

  const EMPTY_SALARY = {
    earnings: {
      basic: "",
      hra: "",
      conveyance: "",
      special: "",
      other: "",
    },
    deductions: {
      advance: "",
      other: "",
    },
  };

  useEffect(() => {
    if (agentData && show) {
      const mapped = {
        emp_id: String(agentData.emp_id ?? ""),
        first_name: agentData.first_name ?? "",
        last_name: agentData.last_name ?? "",
        phone_number: String(agentData.phone_number ?? ""),
        email: agentData.email ?? "",
        date_joined: agentData.date_joined ?? "",
        attendence_type: agentData.attendence_type ?? "web/app",
        role: roletype,
        user_permissions: agentData.user_permissions ?? [],

        designation: agentData.designation ?? "",
        department: agentData.department ?? "",
        gender: agentData.gender ?? "",
        employment_type: agentData.employment_type ?? "permanent",
        is_location: agentData.is_location ?? false,

        family: agentData?.family_details
          ? { ...EMPTY_FAMILY, ...agentData?.family_details }
          : EMPTY_FAMILY,

        bank: agentData.bank_details
          ? { ...EMPTY_BANK, ...agentData?.bank_details }
          : EMPTY_BANK,

        other: agentData.other_details
          ? { ...EMPTY_OTHER, ...agentData?.other_details }
          : EMPTY_OTHER,

        contact: agentData.contact_details
          ? { ...EMPTY_CONTACT, ...agentData?.contact_details }
          : EMPTY_CONTACT,

        resident: agentData.resident_details
          ? { ...EMPTY_RESIDENT, ...agentData.resident_details }
          : EMPTY_RESIDENT,

        permanent: agentData.permanent_details
          ? { ...EMPTY_PERMANENT, ...agentData.permanent_details }
          : EMPTY_PERMANENT,

        salary: agentData.salary
          ? {
              earnings: {
                ...EMPTY_SALARY.earnings,
                ...(agentData.salary.earnings || {}),
              },
              deductions: {
                ...EMPTY_SALARY.deductions,
                ...(agentData.salary.deductions || {}),
              },
            }
          : EMPTY_SALARY,

        qualifications:
          agentData.qualifications?.length > 0
            ? agentData.qualifications.map((q) => ({
                qualification: q.qualification ?? "",
                board: q.board ?? "",
                marks: q.marks ?? "",
                grade: q.grade ?? "",
                year: q.year ?? "",
              }))
            : [
                {
                  qualification: "",
                  board: "",
                  marks: "",
                  grade: "",
                  year: "",
                },
              ],

        experiences:
          agentData.experiences?.length > 0
            ? agentData.experiences.map((e) => ({
                company: e.company ?? "",
                designation: e.designation ?? "",
                years: e.years ?? "",
                salary: e.salary ?? "",
                reason: e.reason ?? "",
              }))
            : [
                {
                  company: "",
                  designation: "",
                  years: "",
                  salary: "",
                  reason: "",
                },
              ],
      };

      setFormData(mapped);
      setInitialData(mapped);
      setAllowedPermissions(agentData.user_permissions ?? []);
    }

    if (!agentData && show) resetForm();
  }, [agentData, show]);

  const resetForm = () => {
    setFormData((prev) => ({
      ...prev,
      emp_id: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      date_joined: "",
      attendence_type: "web/app",
      user_permissions: [],
      designation: "",
      department: "",
      gender: "",
      employment_type: "permanent",
      is_location: false,
      family: {
        father_first_name: "",
        father_last_name: "",
        mother_first_name: "",
        mother_last_name: "",
        marital_status: "",
        spouse_first_name: "",
        spouse_last_name: "",
      },
      bank: {
        account_no: "",
        bank_name: "",
        ifsc: "",
        branch: "",
        payment_type: "",
      },
      other: {
        blood_group: "",
        religion: "",

        nationality: "",
      },
      salary: {
        earnings: {
          basic: "",
          hra: "",
          conveyance: "",
          special: "",
          other: "",
        },
        deductions: {
          advance: "",
          other: "",
        },
      },

      qualifications: [
        { qualification: "", board: "", marks: "", grade: "", year: "" },
      ],
      experiences: [
        {
          company: "",
          designation: "",
          years: "",
          salary: "",
          reason: "",
        },
      ],
      resident: {
        res_address: "",
        res_country: "",
        res_state: "",
        res_city: "",
        res_pincode: "",
      },
      permanent: {
        perm_same_as_res: false,
        perm_address: "",
        perm_country: "",
        perm_state: "",
        perm_city: "",
        perm_pincode: "",
      },
      contact: {
        mobile_no: "",
        emergency_no: "",
      },
    }));
    setAllowedPermissions([]);
    setErrors({});
    setInitialData(null);
  };

  const addRow = (section, emptyRow) => {
    setFormData((prev) => ({
      ...prev,
      [section]: [...prev[section], emptyRow],
    }));
  };

  const handleSameAddress = (checked) => {
    setFormData((prev) => ({
      ...prev,
      permanent: {
        ...prev.permanent,
        perm_same_as_res: checked,
        perm_address: checked ? prev.resident.res_address : "",
        perm_country: checked ? prev.resident.res_country : "",
        perm_state: checked ? prev.resident.res_state : "",
        perm_city: checked ? prev.resident.res_city : "",
        perm_pincode: checked ? prev.resident.res_pincode : "",
      },
    }));
  };

  const updateField = (field, value) => {
    setFormData((p) => ({
      ...p,
      [field]: value,
    }));
    setErrors((e) => ({ ...e, [field]: "" }));
  };
  const updateNestedField = (parent, child, value) => {
    setFormData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [child]: value,
      },
    }));
  };

  const updateArrayField = (section, index, field, value) => {
    setFormData((prev) => {
      const updated = [...(prev[section] || [])];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return { ...prev, [section]: updated };
    });
  };

  const handleNumericField = (field, value, maxLength) => {
    let v = value.replace(/\D/g, "");
    if (maxLength) v = v.slice(0, maxLength);
    setFormData((p) => ({ ...p, [field]: v }));
  };

  const removeRow = (section, index) => {
    setFormData((prev) => {
      if (prev[section].length === 1) return prev;

      const updated = prev[section].filter((_, i) => i !== index);
      return { ...prev, [section]: updated };
    });
  };
  const validateEmployeeTab = () => {
    const err = {};

    if (!/^\d{1,4}$/.test(formData.emp_id))
      err.emp_id = "User ID required (1–4 digits)";

    if (!formData.first_name) err.first_name = "First name required";

    if (!/^\d{10}$/.test(formData.phone_number))
      err.phone_number = "10 digit phone number required";

    if (!/\S+@\S+\.\S+/.test(formData.email))
      err.email = "Valid email required";

    if (!formData.date_joined) err.date_joined = "Date of joining required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleNestedNumericField = (parent, child, value, maxLength) => {
    let v = value.replace(/\D/g, "");
    if (maxLength) v = v.slice(0, maxLength);

    setFormData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [child]: v,
      },
    }));
  };

  const buildPayload = () => {
    const payload = {
      emp_id: formData.emp_id,
      first_name: formData.first_name,
      last_name: formData.last_name,
      phone_number: formData.phone_number,
      email: formData.email,
      date_joined: formData.date_joined,
      attendence_type: formData.attendence_type,
      role: roletype,
      user_permissions: allowedPermissions,
      designation: formData.designation,
      department: formData.department,
      gender: formData.gender,
      employment_type: formData.employment_type,
      is_location: formData.is_location,

      family_details: formData.family,
      bank_details: formData.bank,
      other_details: formData.other,
      resident_details: formData.resident,
      permanent_details: formData.permanent,
      contact_details: formData.contact,
      salary: formData.salary,

      qualifications: formData.qualifications,
      experiences: formData?.experiences,
    };

    if (initialData) {
      Object.keys(payload).forEach((k) => {
        if (k === "communication_details") return;
        if (k === "is_location") return;

        if (JSON.stringify(payload[k]) === JSON.stringify(initialData[k])) {
          delete payload[k];
        }
      });
    }

    return payload;
  };

  const handleSubmit = async () => {
    if (!validateEmployeeTab()) {
      setActiveTab("employee");
      toast.error("Please Provide Correct User Information.");
      return;
    }

    setLoading(true);
    try {
      const payload = buildPayload();

      if (agentData?.id) {
        if (!Object.keys(payload).length) {
          toast.info("No changes detected");
          return;
        }
        await axios.put(
          `${BASE_URL}/users/tms_users/${agentData.id}/`,
          payload,
          { headers: HEADERS },
        );
        toast.success("User updated successfully");
      } else {
        await axios.post(`${BASE_URL}/users/tms_users/`, payload, {
          headers: HEADERS,
        });
        toast.success("User added successfully");
      }

      fetchAgents();
      handleClose();
    } catch (err) {
      if (err.response?.data?.error) {
        Object.values(err.response.data.error).forEach((messages) => {
          messages.forEach((msg) => {
            toast.error(msg);
          });
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>{agentData ? "Edit User" : "Add User"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Tabs activeKey={activeTab} onSelect={setActiveTab}>
          <Tab eventKey="employee" title="User Information">
            <Row className="mb-3 mt-3">
              <Col md={6}>
                <Form.Label>User ID *</Form.Label>
                <Form.Control
                  value={formData.emp_id}
                  onChange={(e) =>
                    handleNumericField("emp_id", e.target.value, 4)
                  }
                  isInvalid={!!errors.emp_id}
                />
              </Col>

              <Col md={6}>
                <Form.Label>Date of Joining *</Form.Label>
                <Form.Control
                  type="date"
                  value={formData.date_joined}
                  onChange={(e) => updateField("date_joined", e.target.value)}
                  isInvalid={!!errors.date_joined}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>First Name *</Form.Label>
                <Form.Control
                  value={formData.first_name}
                  onChange={(e) => updateField("first_name", e.target.value)}
                  isInvalid={!!errors.first_name}
                />
              </Col>

              <Col md={6}>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  value={formData.last_name}
                  onChange={(e) => updateField("last_name", e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  value={formData.email}
                  onChange={(e) => updateField("email", e.target.value)}
                  isInvalid={!!errors.email}
                />
              </Col>

              <Col md={6}>
                <Form.Label>Mobile *</Form.Label>
                <Form.Control
                  value={formData.phone_number}
                  onChange={(e) =>
                    handleNumericField("phone_number", e.target.value, 10)
                  }
                  isInvalid={!!errors.phone_number}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  value={formData.designation}
                  onChange={(e) => updateField("designation", e.target.value)}
                />
              </Col>

              <Col md={6}>
                <Form.Label>Department</Form.Label>
                <Form.Control
                  value={formData?.department}
                  onChange={(e) => updateField("department", e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  value={formData?.gender}
                  onChange={(e) => updateField("gender", e.target.value)}
                >
                  <option value="">Select</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </Form.Select>
              </Col>

              <Col md={6}>
                <Form.Label>Employment Type</Form.Label>
                <Form.Select
                  value={formData?.employment_type}
                  onChange={(e) =>
                    updateField("employment_type", e.target.value)
                  }
                >
                  <option value="permanent">Permanent</option>
                  <option value="contract">Contract</option>
                  <option value="temporary">Temporary</option>
                </Form.Select>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                {" "}
                <Form.Group>
                  <Form.Label>Attendance Type</Form.Label>
                  <div className="d-flex gap-4 mt-2">
                    {["web/app", "machine", "both"].map((type) => (
                      <Form.Check
                        key={type}
                        type="radio"
                        label={type.toUpperCase()}
                        checked={formData?.attendence_type === type}
                        onChange={() => updateField("attendence_type", type)}
                      />
                    ))}
                  </div>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Punch Location</Form.Label>
                  <div className="d-flex gap-4 mt-2">
                    <Form.Check
                      type="radio"
                      label="Anywhere"
                      checked={formData?.is_location === false}
                      onChange={() => updateField("is_location", false)}
                    />

                    <Form.Check
                      type="radio"
                      label="Within Company Premises"
                      checked={formData?.is_location === true}
                      onChange={() => updateField("is_location", true)}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Button
              variant="outline-primary"
              onClick={() => setShowPermissionModal(true)}
              className="mt-3"
            >
              {allowedPermissions.length
                ? "Edit Permissions"
                : "Select Permissions"}
            </Button>
          </Tab>

          <Tab eventKey="family" title="Family / Misc Details">
            <h6 className="mt-3">Family Details</h6>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Father's First Name</Form.Label>
                <Form.Control
                  value={formData.family.father_first_name}
                  onChange={(e) =>
                    updateNestedField(
                      "family",
                      "father_first_name",
                      e.target.value,
                    )
                  }
                />
              </Col>
              <Col md={6}>
                <Form.Label>Father's Last Name</Form.Label>
                <Form.Control
                  value={formData.family.father_last_name}
                  onChange={(e) =>
                    updateNestedField(
                      "family",
                      "father_last_name",
                      e.target.value,
                    )
                  }
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Mother's First Name</Form.Label>
                <Form.Control
                  value={formData.family.mother_first_name}
                  onChange={(e) =>
                    updateNestedField(
                      "family",
                      "mother_first_name",
                      e.target.value,
                    )
                  }
                />
              </Col>
              <Col md={6}>
                <Form.Label>Mother's Last Name</Form.Label>
                <Form.Control
                  value={formData.family.mother_last_name}
                  onChange={(e) =>
                    updateNestedField(
                      "family",
                      "mother_last_name",
                      e.target.value,
                    )
                  }
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={4}>
                <Form.Label>Marital Status</Form.Label>
                <Form.Select
                  value={formData.family.marital_status}
                  onChange={(e) =>
                    updateNestedField(
                      "family",
                      "marital_status",
                      e.target.value,
                    )
                  }
                >
                  <option value="">Select</option>
                  <option>Single</option>
                  <option>Married</option>
                </Form.Select>
              </Col>

              <Col md={4}>
                <Form.Label>Spouse First Name</Form.Label>
                <Form.Control
                  value={formData.family.spouse_first_name}
                  onChange={(e) =>
                    updateNestedField(
                      "family",
                      "spouse_first_name",
                      e.target.value,
                    )
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>Spouse Last Name</Form.Label>
                <Form.Control
                  value={formData.family.spouse_last_name}
                  onChange={(e) =>
                    updateNestedField(
                      "family",
                      "spouse_last_name",
                      e.target.value,
                    )
                  }
                />
              </Col>
            </Row>

            <h6>Bank Details</h6>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Account No</Form.Label>
                <Form.Control
                  value={formData.bank.account_no}
                  onChange={(e) =>
                    updateNestedField("bank", "account_no", e.target.value)
                  }
                />
              </Col>
              <Col md={6}>
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  value={formData.bank.bank_name}
                  onChange={(e) =>
                    updateNestedField("bank", "bank_name", e.target.value)
                  }
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Label>IFSC</Form.Label>
                <Form.Control
                  value={formData.bank.ifsc}
                  onChange={(e) =>
                    updateNestedField("bank", "ifsc", e.target.value)
                  }
                />
              </Col>
              <Col md={4}>
                <Form.Label>Branch</Form.Label>
                <Form.Control
                  value={formData.bank.branch}
                  onChange={(e) =>
                    updateNestedField("bank", "branch", e.target.value)
                  }
                />
              </Col>
              <Col md={4}>
                <Form.Label>Payment Type</Form.Label>
                <Form.Control
                  value={formData.bank.payment_type}
                  onChange={(e) =>
                    updateNestedField("bank", "payment_type", e.target.value)
                  }
                />
              </Col>
            </Row>

            <h6>Other Details</h6>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Label>Blood Group</Form.Label>
                <Form.Control
                  value={formData.other.blood_group}
                  onChange={(e) =>
                    updateNestedField("other", "blood_group", e.target.value)
                  }
                />
              </Col>
              <Col md={4}>
                <Form.Label>Religion</Form.Label>
                <Form.Control
                  value={formData.other.religion}
                  onChange={(e) =>
                    updateNestedField("other", "religion", e.target.value)
                  }
                />
              </Col>
              <Col md={4}>
                <Form.Label>Nationality</Form.Label>
                <Form.Control
                  value={formData.other.nationality}
                  onChange={(e) =>
                    updateNestedField("other", "nationality", e.target.value)
                  }
                />
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="salary" title="Earnings & Deductions">
            <h6 className="mt-3">User's Earning Detail</h6>
            <Row className="mb-3">
              {[
                ["basic", "Basic Allowance"],
                ["hra", "HRA Allowance"],
                ["conveyance", "Conveyance Allowance"],
                ["special", "Spl. Allowance"],
                ["other", "Other Allowance"],
              ].map(([key, label]) => (
                <Col md={4} key={key}>
                  <Form.Label>{label}</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.salary?.earnings?.[key] ?? ""}
                    onChange={(e) =>
                      updateNestedField("salary", "earnings", {
                        ...formData.salary.earnings,
                        [key]: e.target.value,
                      })
                    }
                  />
                </Col>
              ))}
            </Row>

            <h6 className="mt-3">User's Deduction Detail</h6>
            <Row>
              <Col md={4}>
                <Form.Label>Advance Amount</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.salary.deductions.advance}
                  onChange={(e) =>
                    updateNestedField("salary", "deductions", {
                      ...formData.salary.deductions,
                      advance: e.target.value,
                    })
                  }
                />
              </Col>

              <Col md={4}>
                <Form.Label>Other Deduction</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.salary.deductions.other}
                  onChange={(e) =>
                    updateNestedField("salary", "deductions", {
                      ...formData.salary.deductions,
                      other: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="qualification" title="Qualification & Experience">
            <h6 className="mt-3">Educational Qualification</h6>

            {formData.qualifications.map((q, index) => (
              <div
                key={index}
                className="mb-4 p-3 border rounded bg-white position-relative"
              >
                {formData.qualifications.length > 1 && (
                  <Button
                    variant="danger"
                    size="sm"
                    className="position-absolute top-0 end-0 m-2"
                    onClick={() => removeRow("qualifications", index)}
                  >
                    ✖
                  </Button>
                )}

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Label>Qualification</Form.Label>
                    <Form.Control
                      value={q.qualification}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "qualification",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Label>Board / College</Form.Label>
                    <Form.Control
                      value={q.board}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "board",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <Form.Label>Marks (%)</Form.Label>
                    <Form.Control
                      value={q.marks}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "marks",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  <Col md={4}>
                    <Form.Label>Grade</Form.Label>
                    <Form.Control
                      value={q.grade}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "grade",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  <Col md={4}>
                    <Form.Label>Passing Year</Form.Label>
                    <Form.Control
                      value={q.year}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "year",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            <Button
              size="sm"
              variant="outline-primary"
              className="mb-4"
              onClick={() =>
                addRow("qualifications", {
                  qualification: "",
                  board: "",
                  marks: "",
                  grade: "",
                  year: "",
                })
              }
            >
              + Add Qualification
            </Button>

            <hr />

            <h6>Work Experience</h6>

            {formData.experiences?.map((exp = {}, index) => (
              <div
                key={index}
                className="mb-4 p-3 border rounded bg-white position-relative"
              >
                {formData.experiences.length > 1 && (
                  <Button
                    variant="danger"
                    size="sm"
                    className="position-absolute top-0 end-0 m-2"
                    onClick={() => removeRow("experiences", index)}
                  >
                    ✖
                  </Button>
                )}

                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Label>Previous Company</Form.Label>
                    <Form.Control
                      value={exp.company}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "company",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  <Col md={6}>
                    <Form.Label>Designation</Form.Label>
                    <Form.Control
                      value={exp.designation}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "designation",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <Form.Label>Worked Years</Form.Label>
                    <Form.Control
                      value={exp.years}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "years",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  <Col md={4}>
                    <Form.Label>Annual Salary</Form.Label>
                    <Form.Control
                      type="number"
                      value={exp.salary}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "salary",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  <Col md={4}>
                    <Form.Label>Reason for Leaving</Form.Label>
                    <Form.Control
                      value={exp.reason}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "reason",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            <Button
              size="sm"
              variant="outline-primary"
              onClick={() =>
                addRow("experiences", {
                  company: "",
                  designation: "",
                  years: "",
                  salary: "",
                  reason: "",
                })
              }
            >
              + Add Experience
            </Button>
          </Tab>

          <Tab eventKey="communication" title="Communication Details">
            <h6 className="mt-3">Residential Address</h6>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={formData.resident.res_address}
                  onChange={(e) =>
                    updateNestedField("resident", "res_address", e.target.value)
                  }
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Country</Form.Label>
                <Form.Control
                  value={formData.resident.res_country}
                  onChange={(e) =>
                    updateNestedField("resident", "res_country", e.target.value)
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Label>State</Form.Label>
                <Form.Control
                  value={formData.resident.res_state}
                  onChange={(e) =>
                    updateNestedField("resident", "res_state", e.target.value)
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Label>City</Form.Label>
                <Form.Control
                  value={formData.resident.res_city}
                  onChange={(e) =>
                    updateNestedField("resident", "res_city", e.target.value)
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.resident.res_pincode}
                  onChange={(e) =>
                    updateNestedField("resident", "res_pincode", e.target.value)
                  }
                />
              </Col>
            </Row>

            <Form.Check
              type="checkbox"
              className="mb-3"
              label="Permanent Address same as Residential Address"
              checked={formData.permanent.perm_same_as_res}
              onChange={(e) => handleSameAddress(e.target.checked)}
            />

            <h6>Permanent Address</h6>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={formData.permanent.perm_address}
                  disabled={formData.permanent.perm_same_as_res}
                  onChange={(e) =>
                    updateNestedField(
                      "permanent",
                      "perm_address",
                      e.target.value,
                    )
                  }
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Country</Form.Label>
                <Form.Control
                  value={formData.permanent.perm_country}
                  disabled={formData.permanent.perm_same_as_res}
                  onChange={(e) =>
                    updateNestedField(
                      "permanent",
                      "perm_country",
                      e.target.value,
                    )
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Label>State</Form.Label>
                <Form.Control
                  value={formData.permanent.perm_state}
                  disabled={formData.permanent.perm_same_as_res}
                  onChange={(e) =>
                    updateNestedField("permanent", "perm_state", e.target.value)
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Label>City</Form.Label>
                <Form.Control
                  value={formData.permanent.perm_city}
                  disabled={formData.permanent.perm_same_as_res}
                  onChange={(e) =>
                    updateNestedField("permanent", "perm_city", e.target.value)
                  }
                />
              </Col>
              <Col md={3}>
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.permanent.perm_pincode}
                  disabled={formData.permanent.perm_same_as_res}
                  onChange={(e) =>
                    updateNestedField(
                      "permanent",
                      "perm_pincode",
                      e.target.value,
                    )
                  }
                />
              </Col>
            </Row>

            <h6>Contact Details</h6>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Mobile No</Form.Label>
                <Form.Control
                  value={formData.contact?.mobile_no}
                  onChange={(e) =>
                    handleNestedNumericField(
                      "contact",
                      "mobile_no",
                      e.target.value,
                      10,
                    )
                  }
                />
              </Col>
              <Col md={6}>
                <Form.Label>Emergency No</Form.Label>
                <Form.Control
                  value={formData.contact?.emergency_no}
                  onChange={(e) =>
                    handleNestedNumericField(
                      "contact",
                      "emergency_no",
                      e.target.value,
                      10,
                    )
                  }
                />
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Save"}
        </Button>
      </Modal.Footer>

      {showPermissionModal && (
        <PermissionModal
          show={showPermissionModal}
          handleClose={() => setShowPermissionModal(false)}
          setAllowedPermissions={setAllowedPermissions}
          userEditDetails={{ permissions: allowedPermissions }}
          agentData={agentData}
        />
      )}
    </Modal>
  );
}

export default AgentModal;
